/*
  Spirit Sox — shared storefront helpers
  - SSCart.add(): adds variants and opens Dawn's cart drawer (or updates the cart bubble)
  - Bundle meters: any element with [data-ss-bundle-meter] tracks the cart
  - Reveal: gentle fade/slide for [data-ss-reveal] elements, off with reduced motion
*/
(function () {
  if (window.SSCart) return;

  var root = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';
  var locale = document.documentElement.lang || 'en-US';
  var listeners = [];
  var lastCart = null;

  function money(cents, currency) {
    try {
      return new Intl.NumberFormat(locale, { style: 'currency', currency: currency || 'USD' }).format(cents / 100);
    } catch (e) {
      return '$' + (cents / 100).toFixed(2);
    }
  }

  function getCart() {
    return fetch(root + 'cart.js', { headers: { Accept: 'application/json' } })
      .then(function (r) { return r.json(); })
      .then(function (cart) {
        lastCart = cart;
        listeners.forEach(function (fn) { try { fn(cart); } catch (e) {} });
        return cart;
      });
  }

  function updateBubble(sections) {
    var bubble = document.getElementById('cart-icon-bubble');
    if (!bubble || !sections || !sections['cart-icon-bubble']) return;
    var doc = new DOMParser().parseFromString(sections['cart-icon-bubble'], 'text/html');
    var inner = doc.querySelector('.shopify-section');
    bubble.innerHTML = inner ? inner.innerHTML : doc.body.innerHTML;
  }

  /* items: [{ id, quantity, properties }] — resolves with the cart/add response */
  function add(items, opts) {
    opts = opts || {};
    var drawer = document.querySelector('cart-drawer');
    var notification = document.querySelector('cart-notification');
    var target = drawer || notification;
    var body = { items: items };
    if (target && typeof target.getSectionsToRender === 'function') {
      body.sections = target.getSectionsToRender().map(function (s) { return s.id; });
      body.sections_url = window.location.pathname;
    } else {
      body.sections = ['cart-icon-bubble'];
    }

    return fetch(root + 'cart/add.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify(body)
    })
      .then(function (r) {
        return r.json().then(function (data) { return { ok: r.ok, data: data }; });
      })
      .then(function (res) {
        var data = res.data;
        if (!res.ok || data.status) {
          var err = new Error(data.description || data.message || 'Could not add to cart');
          err.data = data;
          throw err;
        }
        var first = data.items && data.items[0];
        if (first) {
          data.id = first.variant_id;
          data.key = first.key;
        }
        if (target && typeof target.renderContents === 'function' && opts.openDrawer !== false) {
          if (drawer && drawer.classList.contains('is-empty')) drawer.classList.remove('is-empty');
          target.renderContents(data);
        } else {
          updateBubble(data.sections);
        }
        if (typeof publish === 'function' && typeof PUB_SUB_EVENTS !== 'undefined') {
          publish(PUB_SUB_EVENTS.cartUpdate, { source: 'ss-cart', productVariantId: data.id, cartData: data });
        }
        getCart();
        return data;
      });
  }

  function onChange(fn) {
    listeners.push(fn);
    if (lastCart) fn(lastCart);
  }

  window.SSCart = { add: add, getCart: getCart, onChange: onChange, money: money };
  document.dispatchEvent(new CustomEvent('ss:ready'));

  /* ---------- Bundle meters ---------- */
  function tiersFrom(el) {
    return ['t1', 't2', 't3'].map(function (k) {
      var p = (el.dataset[k] || '0:0').split(':');
      return { qty: parseInt(p[0], 10), pct: parseFloat(p[1]) };
    }).filter(function (t) { return t.qty > 0; });
  }

  function fill(tpl, qty, pct, count) {
    return (tpl || '').replace('[qty]', qty).replace('[pct]', pct).replace('[count]', count);
  }

  function thumb(url) {
    if (!url) return '';
    return url + (url.indexOf('?') > -1 ? '&' : '?') + 'width=120';
  }

  function eligible(item, el) {
    if (!item.requires_shipping) return false;
    var title = (item.product_title || item.title || '').toLowerCase();
    return !(el.dataset.exclude || '').split(',').some(function (ex) {
      ex = ex.trim().toLowerCase();
      return ex && title.indexOf(ex) > -1;
    });
  }
  window.SSBundleEligible = eligible;

  function renderMeter(el, cart) {
    var tiers = tiersFrom(el);
    if (!tiers.length) return;
    var t1 = tiers[0], tLast = tiers[tiers.length - 1];
    var pairs = 0, original = 0, images = [];
    (cart.items || []).forEach(function (item) {
      if (!eligible(item, el)) return;
      pairs += item.quantity;
      original += item.original_line_price;
      for (var q = 0; q < item.quantity; q++) images.push(item.image);
    });
    var active = null;
    tiers.forEach(function (t) { if (pairs >= t.qty) active = t; });
    var pct = active ? active.pct : 0;
    var next = null;
    tiers.forEach(function (t) { if (!next && pairs < t.qty) next = t; });

    /* Only say "applied" when the cart really shows a discount */
    var discounted = (cart.total_discount || 0) > 0;
    var nextTpl = discounted ? el.dataset.msgNext : (el.dataset.msgNextOff || el.dataset.msgNext);
    var maxTpl = discounted ? el.dataset.msgMax : (el.dataset.msgMaxOff || el.dataset.msgMax);

    var msg;
    if (pairs === 0) msg = fill(el.dataset.msgStart, t1.qty, t1.pct, pairs);
    else if (!active) msg = fill(el.dataset.msgMore, t1.qty - pairs, t1.pct, pairs);
    else if (next) msg = fill(nextTpl, next.qty - pairs, next.pct, pairs);
    else msg = fill(maxTpl, pairs, pct, pairs);

    /* Real cart total, not an estimate */
    var total = typeof cart.total_price === 'number' ? cart.total_price : original;

    el.querySelectorAll('[data-ss-slots]').forEach(function (wrap) {
      Array.prototype.forEach.call(wrap.children, function (slot, i) {
        var src = images[i];
        slot.classList.toggle('is-filled', !!src);
        if (src) {
          slot.innerHTML = '';
          var im = document.createElement('img');
          im.src = thumb(src);
          im.alt = '';
          im.loading = 'lazy';
          im.width = 60;
          im.height = 60;
          slot.appendChild(im);
        } else {
          slot.textContent = String(i + 1);
        }
      });
    });
    el.querySelectorAll('[data-ss-tier]').forEach(function (li) {
      li.classList.toggle('is-active', !!active && parseInt(li.dataset.ssTier, 10) === active.qty);
    });
    el.querySelectorAll('[data-ss-msg]').forEach(function (m) { m.textContent = msg; });
    el.querySelectorAll('[data-ss-pairs]').forEach(function (p) {
      p.textContent = pairs + ' ' + (pairs === 1 ? (el.dataset.pair || 'pair') : (el.dataset.pairs || 'pairs'));
    });
    el.querySelectorAll('[data-ss-was]').forEach(function (w) {
      w.hidden = !discounted;
      w.textContent = money(original, cart.currency);
    });
    el.querySelectorAll('[data-ss-total]').forEach(function (t) { t.textContent = money(total, cart.currency); });
    el.querySelectorAll('[data-ss-progress]').forEach(function (bar) {
      bar.style.setProperty('--ss-progress', Math.min(100, Math.round((pairs / tLast.qty) * 100)) + '%');
    });
    if (el.hasAttribute('data-ss-hide-empty')) el.hidden = pairs === 0;
  }

  function initMeters() {
    var meters = document.querySelectorAll('[data-ss-bundle-meter]');
    if (!meters.length || initMeters.bound) return;
    initMeters.bound = true;
    onChange(function (cart) {
      document.querySelectorAll('[data-ss-bundle-meter]').forEach(function (el) { renderMeter(el, cart); });
    });
  }

  /* ---------- Reveal ---------- */
  function initReveal() {
    var els = document.querySelectorAll('[data-ss-reveal]:not(.is-visible)');
    if (!els.length) return;
    var reduce = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
    if (reduce || !('IntersectionObserver' in window) || (window.Shopify && window.Shopify.designMode)) {
      els.forEach(function (el) { el.classList.add('is-visible'); });
      return;
    }
    var io = new IntersectionObserver(function (entries) {
      entries.forEach(function (entry) {
        if (entry.isIntersecting) {
          entry.target.classList.add('is-visible');
          io.unobserve(entry.target);
        }
      });
    }, { rootMargin: '0px 0px -8% 0px', threshold: 0.05 });
    els.forEach(function (el) { io.observe(el); });
  }

  function trackHeader() {
    var header = document.querySelector('.section-header');
    if (!header) return;
    var set = function () {
      document.body.style.setProperty('--ss-header-h', header.getBoundingClientRect().height + 'px');
    };
    set();
    if ('ResizeObserver' in window) new ResizeObserver(set).observe(header);
    else window.addEventListener('resize', set);
  }

  /* Product cards (collection, search, related): one-tap size buttons */
  document.addEventListener('click', function (e) {
    var btn = e.target.closest && e.target.closest('[data-ss-quick-add] button[data-ss-variant]');
    if (!btn || btn.disabled) return;
    e.preventDefault();
    var box = btn.closest('[data-ss-quick-add]');
    var err = box.querySelector('.ss-qa__error');
    var text = btn.querySelector('.ss-qa__text') || btn;
    var label = text.textContent;
    btn.disabled = true;
    btn.setAttribute('aria-busy', 'true');
    if (err) err.textContent = '';
    add([{ id: Number(btn.dataset.ssVariant), quantity: 1 }])
      .then(function () {
        btn.classList.add('is-added');
        text.textContent = 'Added';
        setTimeout(function () { btn.classList.remove('is-added'); text.textContent = label; }, 1400);
      })
      .catch(function (ex) { if (err) err.textContent = ex.message; })
      .finally(function () { btn.disabled = false; btn.removeAttribute('aria-busy'); });
  });

  document.addEventListener('click', function (e) {
    var a = e.target.closest && e.target.closest('a[href="#ss-size-guide"]');
    if (!a) return;
    var d = document.getElementById('ss-size-guide');
    if (!d) return;
    e.preventDefault();
    d.open = true;
    d.scrollIntoView({ behavior: 'smooth', block: 'center' });
  });

  function boot() {
    document.documentElement.classList.add('ss-js');
    trackHeader();
    initMeters();
    initReveal();
    if (typeof subscribe === 'function' && typeof PUB_SUB_EVENTS !== 'undefined') {
      subscribe(PUB_SUB_EVENTS.cartUpdate, function (event) {
        if (!event || event.source !== 'ss-cart') getCart();
      });
    }
    document.addEventListener('shopify:section:load', function () {
      initMeters();
      initReveal();
      getCart();
    });
    getCart();
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', boot);
  else boot();
})();